/**
 * Auth mode flag.
 * - demo: click-and-go workspace cards only (X-User-Id / X-Org-Id)
 * - jwt: email/password + workspace picker only (Bearer)
 * - dual: both paths available (backend AUTH_MODE=dual)
 */
export function getAuthMode() {
  const raw = String(process.env.REACT_APP_AUTH_MODE || 'demo')
    .trim()
    .toLowerCase();
  if (raw === 'jwt' || raw === 'real') {
    return 'jwt';
  }
  if (raw === 'dual') {
    return 'dual';
  }
  return 'demo';
}

/** JWT login / Bearer tokens are available (jwt or dual). */
export function isJwtAuth() {
  const mode = getAuthMode();
  return mode === 'jwt' || mode === 'dual';
}

/** Demo click-and-go cards are available (demo or dual). */
export function isDemoAuth() {
  const mode = getAuthMode();
  return mode === 'demo' || mode === 'dual';
}

export function isDualAuth() {
  return getAuthMode() === 'dual';
}

/** Strict JWT-only cutover (no demo cards). */
export function isJwtOnly() {
  return getAuthMode() === 'jwt';
}
